module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "ksm-header"
  }, [_c('router-link', {
    staticClass: "ksm-header__title ksm-link-img",
    attrs: {
      "tag": "a",
      "to": "/"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('kurt-merz-schwitters-typo.svg'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1"
  }), _vm._v(" "), _c('nav-view', {
    staticStyle: {
      "order": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac5f4096","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Head.vue
// module id = 1991
// module chunks = 1